var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('nav',{staticClass:"navbar navbar-dark"},[_c('p',[_vm._v("©2021 yumenomatayume")])])])}]

export { render, staticRenderFns }